import { JWT_TOKEN } from '../actions/actionTypes';

const initialState = {
  jwtTokenData: null,
};

const jwtToken = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    if (action.type === JWT_TOKEN) {
      return {
        ...state,
        jwtTokenData: action.payload,
      };
    } else {
      return state;
    }
  }
};

export default jwtToken;
